import { Link, Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@mlm/ui';
import { getMySubscription } from '../lib/api';

/**
 * Gates the subscription-only pages (Special Links). A member is "subscribed"
 * while their paid access window is still open. When it isn't, render a Subscribe
 * CTA instead of the page. Loading defers rendering so the gate doesn't flash.
 */
export function RequireSubscription() {
  const q = useQuery({ queryKey: ['my-subscription'], queryFn: getMySubscription });
  if (q.isLoading) {
    return <p className="text-sm text-muted-foreground">Loading…</p>;
  }
  const active = q.data?.subscription?.isActive ?? false;
  if (!active) {
    return (
      <Card className="max-w-lg mx-auto mt-12">
        <CardHeader>
          <CardTitle>Members-only content</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            This content is available to subscribed members. Subscribe to unlock the special live
            links.
          </p>
          <Button asChild size="sm">
            <Link to="/subscribe">Subscribe</Link>
          </Button>
        </CardContent>
      </Card>
    );
  }
  return <Outlet />;
}
